import React from 'react'

export default ({ dealerName }) => {
  return (
    <div className="sales__security-text">
      <strong>Nós levamos a sua privacidade e segurança muito a sério.</strong> A {dealerName} armazena e transmite com segurança todos os dados usando a criptografia de banco de 1024 bits RSA SSL.
    </div>)
}